<template lang="pug">
 //base-nav.navbar-top.border-bottom.navbar-expand(container-classes='container-fluid' :class="{'bg-primary navbar-dark': type === 'default'}")
    // Search form
    b-form#navbar-search-main.navbar-search.form-inline.mr-sm-3(:class="{'navbar-search-light': type === 'default', 'navbar-search-dark': type === 'light'}")
      b-form-group.mb-0
        b-input-group.input-group-alternative.input-group-merge
          .input-group-prepend
            span.input-group-text
              i.fas.fa-search
          b-form-input(placeholder='Search' type='text')  
      button.close(type='button' data-action='search-close' data-target='#navbar-search-main' aria-label='Close')
        span(aria-hidden='true') &times;
    // Navbar links
    b-navbar-nav.align-items-center.ml-md-auto
      // This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here
      //li.nav-item.d-xl-none
        // Sidenav toggler
        .pr-3.sidenav-toggler(:class="{active: $sidebar.showSidebar, 'sidenav-toggler-dark': type === 'default', 'sidenav-toggler-light': type === 'light'}" @click='toggleSidebar')
          .sidenav-toggler-inner
            i.sidenav-toggler-line
            i.sidenav-toggler-line
            i.sidenav-toggler-line
      // This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add
      //li.nav-item.d-sm-none
        a.nav-link(href='#' data-action='search-show' data-target='#navbar-search-main')
          i.ni.ni-zoom-split-in
      //base-dropdown.nav-item(tag='li' title-classes='nav-link' title-tag='a' icon='ni ni-bell-55' menu-classes='dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden')
        template
          // Dropdown header
          .px-3.py-3
            h6.text-sm.text-muted.m-0
              | You have 
              strong.text-primary 13
              |  notifications.
          // List group
          b-list-group(flush='')
            b-list-group-item(action='' href='#!')
              b-row(align-v='center')
                b-col(md='auto')
                  // Avatar
                  b-img.avatar(alt='Image placeholder' src='img/theme/team-1.jpg' rounded='circle')
                b-col.ml--2
                  .d-flex.justify-content-between.align-items-center
                    div
                      h4.mb-0.text-sm John Snow
                    .text-right.text-muted
                      small 2 hrs ago
                  p.text-sm.mb-0 Let&apos;s meet at Starbucks at 11:30. Wdyt?
            a.list-group-item.list-group-item-action(href='#!')
              b-row(align-v='center')
                b-col(md='auto')
                  // Avatar
                  b-img.avatar(alt='Image placeholder' src='img/theme/team-2.jpg' rounded='circle')
                b-col.ml--2
                  .d-flex.justify-content-between.align-items-center
                    div
                      h4.mb-0.text-sm John Snow
                    .text-right.text-muted
                      small 3 hrs ago
                  p.text-sm.mb-0 A new issue has been reported for Argon.
            b-list-group-item(action='' href='#!')
              b-row(align-v='center')
                b-col(md='auto')
                  // Avatar
                  b-img.avatar(alt='Image placeholder' src='img/theme/team-3.jpg' rounded='circle')
                b-col.ml--2
                  .d-flex.justify-content-between.align-items-center
                    div
                      h4.mb-0.text-sm John Snow
                    .text-right.text-muted
                      small 5 hrs ago
                  p.text-sm.mb-0 Your posts have been liked a lot.
            b-list-group-item(action='' href='#!')
              b-row(align-v='center')
                b-col(md='auto')
                  // Avatar
                  b-img.avatar(alt='Image placeholder' src='img/theme/team-4.jpg' rounded='circle')
                b-col.ml--2
                  .d-flex.justify-content-between.align-items-center
                    div
                      h4.mb-0.text-sm John Snow
                    .text-right.text-muted
                      small 2 hrs ago
                  p.text-sm.mb-0 Let&apos;s meet at Starbucks at 11:30. Wdyt?
            b-list-group-item(action='' href='#!')
              b-row(align-v='center')
                b-col(md='auto')
                  // Avatar
                  b-img.avatar(alt='Image placeholder' src='img/theme/team-5.jpg' rounded='circle')
                b-col.ml--2
                  .d-flex.justify-content-between.align-items-center
                    div
                      h4.mb-0.text-sm John Snow
                    .text-right.text-muted
                      small 3 hrs ago
                  p.text-sm.mb-0 A new issue has been reported for Argon.
          // View all
          // This item dont have <b-dropdown-item> because item have styles " text-center text-primary font-weight-bold py-3" on tag <a> wich we cant add
          a.dropdown-item.text-center.text-primary.font-weight-bold.py-3(href='#!') View all
      //base-dropdown.nav-item(menu-classes='dropdown-menu-lg dropdown-menu-dark bg-default dropdown-menu-right' tag='li' title-tag='a' title-classes='nav-link' icon='ni ni-ungroup')
        template
          b-row.shortcuts.px-4
            a.col-4.shortcut-item(href='#!')
              span.shortcut-media.avatar.rounded-circle.bg-gradient-red
                i.ni.ni-calendar-grid-58
              small Calendar
            a.col-4.shortcut-item(href='#!')
              span.shortcut-media.avatar.rounded-circle.bg-gradient-orange
                i.ni.ni-email-83
              small Email
            a.col-4.shortcut-item(href='#!')
              span.shortcut-media.avatar.rounded-circle.bg-gradient-info
                i.ni.ni-credit-card
              small Payments
            a.col-4.shortcut-item(href='#!')
              span.shortcut-media.avatar.rounded-circle.bg-gradient-green
                i.ni.ni-books
              small Reports
            a.col-4.shortcut-item(href='#!')
              span.shortcut-media.avatar.rounded-circle.bg-gradient-purple
                i.ni.ni-pin-3
              small Maps
            a.col-4.shortcut-item(href='#!')
              span.shortcut-media.avatar.rounded-circle.bg-gradient-yellow
                i.ni.ni-basket
              small Shop
    b-navbar-nav.align-items-center.ml-auto.ml-md-0
      base-dropdown.nav-item(menu-on-right='' tag='li' title-tag='a' title-classes='nav-link pr-0')
        a.nav-link.pr-0(href='#' @click.prevent='' slot='title-container')
          b-media.align-items-center(no-body='')
            span.avatar.avatar-sm.rounded-circle
              
            b-media-body.ml-2.d-none.d-lg-block
              span.mb-0.text-sm.font-weight-bold Christoph
        template
          b-dropdown-header.noti-title
            h6.text-overflow.m-0 Welcome!
          b-dropdown-item(href='#!')
            i.ni.ni-single-02
            span My profile
          b-dropdown-item(href='#!')
            i.ni.ni-settings-gear-65
            span Settings
          b-dropdown-item(href='#!')
            i.ni.ni-calendar-grid-58
            span Activity
          b-dropdown-item(href='#!')
            i.ni.ni-support-16
            span Support
          .dropdown-divider
          b-dropdown-item(href='#!')
            i.ni.ni-user-run
            span Logout

</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: ''
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
};
</script>
